/* eslint-disable react/prop-types */
import React from "react";
import { Text } from "@chakra-ui/react";
import TribalView from "./TribalView";
import useGetConfig from "../../../hooks/useGetConfig";
import LoadingSpinner from "../../../LoadingSpinner";

const Security = () => {
  const { data, isLoading, error } = useGetConfig("Security");
  if (error) {
    return <Text color="red">Something went wrong!</Text>;
  }
  if (isLoading) {
    return <LoadingSpinner />;
  }
  return (
    <div>
      {!data ? (
        <Text color="red">Data not found!</Text>
      ) : (
        <TribalView tribes={data} />
      )}
    </div>
  );
};

export default Security;
